var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonWalking(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140.29 160.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M119.82,146.19c2.9,4.6,1.7,10.2-2,12.6-4.6,3-10.4,1.9-13.3-2.8l-34.8-55.6c-5-8-6.7-15.7-3.9-25.1l5.1-17c-4,0-6.1,2.2-8.2,5.1l-9.8,13.9c-2.5,3.5-8.4,2.4-10.7.2-3.4-3.1-3.4-7.5-.6-11.5l10.7-15.3c4-5.8,25.4-13.6,32.2-13.2l14.9.9c10,6.8,15.3,19.7,22.6,21.2l12.5,2.6c4.1.9,6.2,5.4,5.7,8.6s-3.6,7.7-8.3,6.8l-15.1-2.8c-5.6-1.7-9.6-4.8-14.3-9.9l-12,34.6,29.1,46.6.2.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M78.72,26.99c-4.6-5.8-4.2-12.9-.9-18.8S87.92-.81,95.22.19c8,1,13.3,7.2,14.5,14,1.4,8-3.1,15.3-9.7,18.3s-15.9,1.3-21.3-5.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M70.82,153.59c-2,5.4-6.1,7.8-11.7,6.6s-7.5-6.5-5.7-11.5l14-37.9,12.2,18.9-8.7,23.9h-.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M51.52,114.99H4.42c-1.5,0-4.2-1.6-4.4-2.9s1.2-3.9,2.4-4.7h51.1c1.2.8,2.4,3.3,2.3,4.7s-2.7,2.9-4.3,2.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M48.52,98.79h-30.7c-1.4,0-3.4-2.5-3.4-3.6s2.1-3.6,3.4-3.6l30.4.2c1.6,0,1.9,5.4.3,7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M45.22,130.79l-22.5-.2c-1.7-.6-1.9-6.4,0-6.7,7.1-1.1,15.4-1.5,22.2-.9s3,2.4,3.4,3.4-1.8,4.4-3.1,4.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonWalking);
export default __webpack_public_path__ + "static/media/person-walking.f0cd9aa4d0c36e74fba7847e59a0e20c.svg";
export { ForwardRef as ReactComponent };